export default function Matplotlib_Line() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MatplotlibLine Component</h1>
      <p>This is the MatplotlibLine component.</p>
    </div>
  );
}
